export const clickableObjectTypes = {
    LAYER: 'layer',
    LITHOLOGY: 'lithology',
    CURVES: 'curve',
    PERFORATION: 'perforation',
};
